var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sales-order-lines"
  }, [_c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('b-card', [_c('b-card-title', {
    staticClass: "text-uppercase"
  }, [_vm._v("Informatie")]), _c('b-table-simple', {
    attrs: {
      "small": ""
    }
  }, [_c('colgroup', [_c('col'), _c('col')]), _c('b-tbody', [_c('b-tr', [_c('b-th', [_vm._v("Ordernummer")]), _c('b-td', [_vm._v(_vm._s(_vm.salesOrder.identifier))])], 1), _c('b-tr', [_c('b-th', [_vm._v("Geplaatst op")]), _c('b-td', [_vm._v(_vm._s(_vm.datetime(_vm.salesOrder.created_at)))])], 1), _c('b-tr', [_c('b-th', [_vm._v("Aantal orderregels")]), _c('b-td', [_vm._v(_vm._s(_vm.salesOrderLinesCount))])], 1), _c('b-tr', [_c('b-th', [_vm._v("Totaal aantal producten")]), _c('b-td', [_vm._v(_vm._s(_vm.salesOrderLinesProductCount))])], 1), _vm.grandTotal !== null ? _c('b-tr', [_c('b-th', [_vm._v("Totaal")]), _c('b-td', [_vm._v(_vm._s(_vm.price(_vm.grandTotal)))])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card-title', {
    staticClass: "text-uppercase"
  }, [_vm._v(" Oorspronkelijke orderregels ")]), _vm.searchEnabled ? _c('b-row', {
    attrs: {
      "align-h": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('b-form-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "Zoeken in deze tabel..."
    },
    model: {
      value: _vm.searchFilters.originalSalesOrderLines,
      callback: function ($$v) {
        _vm.$set(_vm.searchFilters, "originalSalesOrderLines", $$v);
      },
      expression: "searchFilters.originalSalesOrderLines"
    }
  })], 1)], 1)], 1) : _vm._e(), _c('b-table', {
    attrs: {
      "selectable": false,
      "items": _vm.salesOrderLinesOriginal,
      "fields": _vm.salesOrderLinesFields,
      "filter": _vm.searchFilters.originalSalesOrderLines,
      "select-mode": "single",
      "stacked": "sm"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card-title', {
    staticClass: "text-uppercase"
  }, [_vm._v(" Toegevoegde orderregels ")]), _vm.searchEnabled ? _c('b-row', {
    attrs: {
      "align-h": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('b-form-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "Zoeken in deze tabel..."
    },
    model: {
      value: _vm.searchFilters.extraSalesOrderLines,
      callback: function ($$v) {
        _vm.$set(_vm.searchFilters, "extraSalesOrderLines", $$v);
      },
      expression: "searchFilters.extraSalesOrderLines"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.extraSalesOrderLinesAvailable ? [_c('b-table', {
    attrs: {
      "selectable": false,
      "items": _vm.salesOrderLinesExtra,
      "fields": _vm.salesOrderLinesFieldsExtra,
      "filter": _vm.searchFilters.extraSalesOrderLines,
      "select-mode": "single",
      "stacked": "sm"
    }
  })] : [_c('p', {
    staticClass: "mt-3"
  }, [_vm._v("Er zijn geen toegevoegde orderregels.")])]], 2)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }